import type { AdminQueryError } from "./admin-query-errors";

export type AdminScreenState<TViewModel> =
  | { status: "idle"; viewModel?: undefined; error?: undefined }
  | { status: "loading"; viewModel?: TViewModel; error?: undefined }
  | { status: "ready"; viewModel: TViewModel; error?: undefined }
  | { status: "empty"; viewModel?: TViewModel; error?: undefined }
  | { status: "partial"; viewModel: TViewModel; error?: AdminQueryError }
  | { status: "stale"; viewModel: TViewModel; error?: AdminQueryError }
  | { status: "permission_denied"; viewModel?: undefined; error: AdminQueryError }
  | { status: "error"; viewModel?: TViewModel; error: AdminQueryError };

export function createIdleAdminScreenState<TViewModel>(): AdminScreenState<TViewModel> {
  return {
    status: "idle",
  };
}

export function createLoadingAdminScreenState<TViewModel>(
  viewModel?: TViewModel,
): AdminScreenState<TViewModel> {
  return {
    status: "loading",
    viewModel,
  };
}
